import { render, staticRenderFns } from "./CategoryDisplay.vue?vue&type=template&id=14ae6535&scoped=true&"
import script from "./CategoryDisplay.vue?vue&type=script&lang=js&"
export * from "./CategoryDisplay.vue?vue&type=script&lang=js&"
import style0 from "./CategoryDisplay.vue?vue&type=style&index=0&id=14ae6535&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ae6535",
  null
  
)

export default component.exports